import { useQuery } from '@tanstack/react-query';

import regularStatus from '../../regular/status';
import fetch from './fetch';

/**
 * @param {object} params
 * @param {string} params.code
 * @param {boolean} params.enabled
 */
function useMtTradelimit({ code: stockCode, enabled: propsEnabled = true } = {}) {
  const { cb, key } = fetch(stockCode);

  const { isMtActive } = regularStatus.useAccountStatus();

  const enabled =
    isMtActive && // Do not call when user does not have MT account
    !!stockCode && // Do not call without stock code
    propsEnabled; // Do not call when service client specifies it

  const { data, isSuccess, refetch } = useQuery(key, cb, { enabled });

  /** Funds that are available for trading */
  const mtBuyingPower = data?.margin_bp || 0;

  /**
   * With a given trading limit, what is the maximum possible trading order volume
   * if user decided to spend all of their funds
   * Formula: `margin_bp - max_fee`
   * If `margin_bp` is less than `max_fee`, return 0
   * */
  const usableMtBuyingPower =
    (data?.margin_bp || 0) > (data?.max_fee || 0)
      ? (data?.margin_bp || 0) - (data?.max_fee || 0)
      : 0;

  return { data, isSuccess, refetch, mtBuyingPower, usableMtBuyingPower };
}

export default {
  useMtTradelimit,
};
